import { useNavigate } from "react-router-dom";
import NotFoundImg from "../../assets/images/Not-Found/NotFound.png";
import { Button } from "primereact/button"; // Import Button from PrimeReact
import Layout from "../layout/layout";

const NotFound = () => {
  const navigate = useNavigate(); // Use the navigate function from React Router

  return (
    <>
      <Layout />
      <div className="tw-flex tw-items-center tw-justify-center tw-ml-[240px] tw-mt-[170px]">
        <div className="tw-bg-white tw-border-dashed tw-rounded-lg tw-p-8 tw-text-center tw-max-w-md tw-w-full">
          <img src={NotFoundImg} alt="NotFoundImg" />
          <p className="tw-text-gray-600 tw-mb-4">
            Sorry, the page you are looking for does not exist.
          </p>

          <Button
            label="Back Home"
            icon="pi pi-angle-left"
            className="tw-p-2 tw-absolute focus:tw-shadow-none tw-ml-[-60px] tw-text-[#182c44] hover:tw-text-[#3e6799] tw-transition hover:tw-text-lg"
            onClick={() => navigate(localStorage.currentModuleUrl ?? "/")} // Navigate to Home
            severity="secondary"
            outlined
          />
        </div>
      </div>
    </>
  );
};

export default NotFound;
